import { Typography } from '@musinsa/mds';
import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';

const DISPLAY_NAME = 'ProductInformation.BrandName';

interface Props {
  brandName: string;
  className?: string;
}

export const BrandName: FC<Props> = ({ brandName, className }) => (
  <Typography variant="textEtc11pxSemibold" className={twMerge('line-clamp-2', className)}>
    {brandName}
  </Typography>
);

BrandName.displayName = DISPLAY_NAME;
